/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { CatalogueItemIndexResponse } from '../types/CatalogueItemIndex'

/**
 * GET /catalogue-items
 * @see backend/nexus/modules/Billing/Http/Controllers/CatalogueItemController.php CatalogueItemController::index
 */
export async function catalogueItemIndex(
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<CatalogueItemIndexResponse>> {
	return axiosInstance.get('/catalogue-items', config)
}
